import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import StepNavigator from 'Components/ComponentLibrary/Molecules/StepNavigator';
import { noop } from 'Helpers/PropTypes';
import WizardStandardHeader from 'Components/ComponentLibrary/Components/Uncategorized/WizardStandardHeader';
import { FDBodyText, FDStack } from '@facet-wealth/design';
import fr from 'facet-rest';
import { LottieLoadingLayout } from 'Organisms/LottieControl/LottieLoadingLayout';
import { LottieRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/LottieRel';

const styles = (theme) => ({
  root: {
    paddingBottom: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginBottom: theme.spacing(10),
    height: '100vh',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  subtitles: {
    padding: 0,
  },
  navigator: {
    left: 0,
  },
  subtitleText: {
    textAlign: 'center',
  },
  infoBox: {
    marginTop: theme.spacing(8),
  },
  grow: {
    flexGrow: 1,
  },
});

const Layout = ({
  classes,
  onNext,
  onPrevious,
}) => {
  const {
    resource,
  } = useMetaLayoutContext();

  const isMobile = useMobileLayout();

  return (
    <Box
      className={classNames(classes.root, {
        [classes.rootDesktop]: !isMobile,
      })}
    >
      <WizardStandardHeader
        color="primaryBlueMuted"
        title={resource.attr('moduleName')}
      />
      <div className={classes.grow}>
        <FDStack spacing={4} direction={'column'}>
          {resource.withRelationship(fr.relationships.lottie.name,
            (rel) => (
              <LottieLoadingLayout>
                <LottieRel relationship={rel} width={'250px'} height={'250px'} />
              </LottieLoadingLayout>
            ),
            () => null)}
          <Typography
            className={classes.title}
            variant={'h1'}
            color={'primary'}
            weight={'medium'}
            align={'center'}
            test={'wizard-step-title'}
          >
            {resource.attr('title')}
          </Typography>
          <FDBodyText value={resource.attr('subtitle')} color={'textDisabled'} align={'center'} />
        </FDStack>
      </div>
      <StepNavigator
        className={classes.navigator}
        onNext={onNext}
        onPrevious={onPrevious}
      >
        {resource.attr('primaryActionText') || 'Continue'}
      </StepNavigator>
    </Box>
  );
};

Layout.defaultProps = {
  onNext: noop,
  onPrevious: undefined,
};

Layout.propTypes = {
  classes: PropTypes.object.isRequired,
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,

};

export default withStyles(styles)(Layout);
